export const PAYTM_CHECKOUT_FRAME = "paytm_checkout_frame";
export const PAYTM_POLL_INTERVAL_MS = 10000;
export const PAYTM_MAX_POLL_MS = 5 * 60 * 1000;
export const PAYTM_POST_RETURN_MAX_RETRIES = 3;
export const PAYTM_POST_RETURN_RETRY_DELAY_MS = 1500;
export const PAYTM_PENDING_ORDER_KEY = "paytm_pending_order_id";

export const extractTxnToken = (data) =>
  data?.txnToken ||
  data?.txn_token ||
  data?.transaction_token ||
  data?.transactionToken ||
  "";

export const extractOrderId = (data) =>
  data?.order_id || data?.Order_Id || data?.orderId || "";

export const extractMid = (data) => data?.mid || data?.MID || "";

export const extractPaymentUrl = (data) =>
  data?.payment_url ||
  data?.payment_link ||
  data?.redirect_url ||
  data?.txn_url ||
  data?.paymentUrl ||
  "";

export const normalizePaymentStatus = (data) =>
  (
    data?.paymentStatus ||
    data?.payment_status ||
    data?.data?.paymentStatus ||
    data?.data?.payment_status ||
    ""
  ).toLowerCase();

export const isTerminalPaymentStatus = (status) =>
  ["completed", "success", "failed", "failure"].includes(status);

export const isPaymentCompleted = (data) => {
  const status = normalizePaymentStatus(data);
  return status === "completed" || status === "success";
};

export const isPaymentPending = (data) =>
  normalizePaymentStatus(data) === "pending";

export const isPaymentFailed = (data) => {
  const status = normalizePaymentStatus(data);
  return status === "failed" || status === "failure";
};

export const isTerminalPaymentResult = (data) =>
  isPaymentCompleted(data) || isPaymentFailed(data);

export const isPaymentStillPending = (data) => {
  const status = normalizePaymentStatus(data);
  const subMessage = (
    data?.receipt?.sub_message ||
    data?.data?.receipt?.sub_message ||
    ""
  ).toLowerCase();

  return (
    (status === "failed" || status === "failure") &&
    (subMessage.includes("not completed") ||
      subMessage.includes("incomplete") ||
      subMessage.includes("pending"))
  );
};

export const shouldFinalizePayment = (data) => {
  if (isPaymentCompleted(data)) return true;
  if (isPaymentStillPending(data)) return false;
  const status = normalizePaymentStatus(data);
  return status === "failed" || status === "failure";
};

// After Paytm redirects back: success may take a moment to reflect in the API.
// Cancel stays "Failed + not completed" — finalize after 2 consecutive pending reads.
export const shouldFinalizeAfterPaytmReturn = (data, pendingFailedStreak = 0) => {
  if (isPaymentCompleted(data)) return true;
  if (shouldFinalizePayment(data)) return true;
  if (pendingFailedStreak >= 2 && isPaymentStillPending(data)) return true;
  return false;
};

export const savePendingOrderId = (orderId) => {
  if (orderId) {
    sessionStorage.setItem(PAYTM_PENDING_ORDER_KEY, orderId);
  }
};

export const getPendingOrderId = () =>
  sessionStorage.getItem(PAYTM_PENDING_ORDER_KEY) || "";

export const clearPendingOrderId = () => {
  sessionStorage.removeItem(PAYTM_PENDING_ORDER_KEY);
};

export const clearAwaitPaymentFromUrl = (history) => {
  const params = new URLSearchParams(window.location.search);
  if (params.get("await_payment") !== "1") return;

  params.delete("await_payment");
  const search = params.toString();
  history.replace(`${window.location.pathname}${search ? `?${search}` : ""}`);
};

export const submitPaytmCheckoutInFrame = (paytmData, frameName = PAYTM_CHECKOUT_FRAME) => {
  const paymentUrl = extractPaymentUrl(paytmData);
  const mid = extractMid(paytmData);
  const orderIdValue = extractOrderId(paytmData);
  const txnToken = extractTxnToken(paytmData);

  if (paymentUrl) {
    const frame = document.getElementsByName(frameName)[0];
    if (frame) {
      frame.src = paymentUrl;
      return true;
    }
    return false;
  }

  if (!mid || !orderIdValue || !txnToken) {
    return false;
  }

  const form = document.createElement("form");
  form.method = "POST";
  form.target = frameName;
  form.action = `https://securegw.paytm.in/theia/api/v1/showPaymentPage?mid=${encodeURIComponent(
    mid
  )}&orderId=${encodeURIComponent(orderIdValue)}`;

  const fields = [
    ["body", JSON.stringify({ head: { txnToken } })],
    ["head", JSON.stringify({ txnToken })],
    ["txnToken", txnToken],
    ["mid", mid],
    ["orderId", orderIdValue],
  ];

  fields.forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

  return true;
};
